import type { UserInviteListResponse } from '../types/UserInviteTypes'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Retrieves all pending invitations for a workspace
 * @param workspaceSlug - The workspace slug (environment)
 * @param options - Query options for pagination and history
 * @returns List of invitations with total count
 */
export async function getPendingInvites(
  workspaceSlug: string,
  options?: {
    includeHistory?: boolean
    skip?: number
    take?: number
  },
): Promise<UserInviteListResponse> {
  const params = new URLSearchParams()

  if (options?.includeHistory) {
    params.append('includeHistory', 'true')
  }
  if (options?.skip !== undefined) {
    params.append('skip', options.skip.toString())
  }
  if (options?.take !== undefined) {
    params.append('take', options.take.toString())
  }

  const queryString = params.toString()
  const url = `/api/v1.0/e/${workspaceSlug}/invites${queryString ? `?${queryString}` : ''}`

  const response = await AuthAxios.get<UserInviteListResponse>(url)

  return response.data
}
